import { render } from "./TeacherType.vue?vue&type=template&id=cf9510c2&scoped=true"
import script from "./TeacherType.vue?vue&type=script&lang=js"
export * from "./TeacherType.vue?vue&type=script&lang=js"

import "./TeacherType.vue?vue&type=style&index=0&id=cf9510c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9510c2"]])

export default __exports__